import {Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import {Feed} from '../../../../models/feed';
import {Answer} from '../../../../models/answer';
import {FeedService} from '../../../../services/feed.service';
import {AuthService} from '../../../../services/auth.service';

import { ModalFeedComponent } from '../../modal-feed/modal-feed.component';



export class AnswerUpdate {

    public id: number;
    public answer: string;

    constructor() {
    }

    populate(data): AnswerUpdate {
        this.id = data.id;
        this.answer = data.answer;
        return this;
    }
}

declare var $: any;
import Swal from 'sweetalert2';


@Component({
  selector: 'app-clientes-feed-answer',
  templateUrl: './answer.component.html',
  styleUrls: ['../../../userpanel.component.css'],
  providers: [FeedService, AuthService]
})

export class FeedAnswerComponent implements OnInit {

    @Input() answer;
    @Input() user;
    @Input() client;
    @Input() comment;
    @Output() delete: EventEmitter<any> = new EventEmitter<any>();
    public formAnswer: FormGroup;
    public update = false;
    public asker = false;

    constructor(
        public fb: FormBuilder,
        private feedService: FeedService
    ) {
        this.buildForm();
    }

    buildForm(): void {
        this.formAnswer = this.fb.group({
            answer: ['', Validators.minLength(5)],
        });
    }

    ngOnInit() {
    }

    OnAnswer(id: number): void {
        this.feedService.publishNewAnswer(this.prepareAnswer(id)).subscribe(res => {
            this.formAnswer.reset();
            this.asker = false;
        })
    }

    OnUpdateAnswer(id: number): void {
        this.feedService.updateAnswer(this.prepareUpdateAnswer(id))
        .subscribe(res => {
          this.answer.answer = res.data.answer
        });
        this.update = false;
      }


    deleteAnswer(id) {
        Swal.fire({
            title: 'Você quer apagar o item?',
            text: 'Você não poderá reverter essa ação depois de confirmado',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then(
            (result) => {
                if (result.value) {
                    this.feedService.deleteAnswer(id).subscribe(
                        res => {
                            this.delete.emit(id)
                        }
                    )                    
                }

            },
            (cancel) => {}
        );
    }

    prepareAnswer(id: number): Answer {
        const formModel = this.formAnswer.value;
        const obj = new Answer();
        obj.answer = formModel.answer;
        obj.comment_feed_id = id;
        return obj;
    }

    prepareUpdateAnswer(id: number): AnswerUpdate {
        const formModel = this.formAnswer.value;
        const obj = new AnswerUpdate();
        obj.answer = formModel.answer;
        obj.id = id;
        return obj;
    }

    askComment(event) {
        this.asker == false ? this.asker = true : this.asker = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/feed/comments/answers/answer.component.ts